import React from "react";

const IconSpinner = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      height={40}
      fill="none"
      {...props}
    >
      <path
        fill="#4F4FFF"
        d="M20 5v3.75A11.25 11.25 0 0 1 31.25 20H35A15 15 0 0 0 20 5Z"
      />
      <path
        fill="#D7DBF5"
        d="M20 31.25a11.25 11.25 0 0 1 0-22.5V5a15 15 0 1 0 15 15h-3.75A11.25 11.25 0 0 1 20 31.25Z"
      />
    </svg>
  );
};

export default IconSpinner;
